export default __webpack_public_path__ + "static/media/no_items.e82846a5.png";